<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal">
    <div :slot="ModalStatus.Confirmation">
      <h3 class="modal-title">Bookmark Page</h3>

      <div class="form-style">
        <div>
          <label for="menu-folder">Select Menu Folder</label>
          <a-select id="menu-folder"
                    v-model="newBookmarkLink.bookmark_folder_id"
                    :options="bookmarkFoldersVOptions"></a-select>
        </div>
        <div>
          <label for="link-name">Link Name</label>
          <input v-model="newBookmarkLink.name" type="text" id="link-name" @keydown.enter="!isDisabled && save()">
        </div>

        <div class="cta">
          <button @click="emitHideModal" type="button" class="btn red outline block">Cancel</button>
          <button @click="save" type="button" class="btn green block" :disabled="isDisabled">Save</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from 'vue';
  import {IVOptionSetLocal} from "../../../../common/interfaces/vSelectInterfaces";
  import BookmarkLink from "../../models/bookmarkLink";
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  const BookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    state: ['bookmarkMenu'],
    actions: ['createBookmarkLink'],
  });

  export default Vue.extend({
    mixins: [BookmarkMenuStoreMixin],
    props: {
      state: {type: Object},
    },
    data: function(): object {
      return {
        newBookmarkLink: new BookmarkLink().loadFromJson({url: window.location.pathname + window.location.search}),
      };
    },
    computed: {
      bookmarkFoldersVOptions(): IVOptionSetLocal {
        const options = this.bookmarkMenu.sortedBookmarkFolders.map(folder => ({label: folder.name, value: folder.id}));
        return { options };
      },
      isDisabled(): boolean {
        return !this.newBookmarkLink.bookmark_folder_id || this.newBookmarkLink.name.length < 1;
      }
    },
    methods: {
      save(): void {
        this.createBookmarkLink({bookmarkLink: this.newBookmarkLink});
        this.emitHideModal();
      },
    },
  })
</script>